import React from 'react';
import { MailIcon, CreditCardIcon, DownloadIcon } from 'lucide-react';
export function HowItWorks() {
  return <section className="bg-white py-2 px-4" data-id="element-215">
      <div className="max-w-3xl mx-auto" data-id="element-216">
        <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-2 text-center" data-id="element-217">
          🔽 ¿Cómo recibís el material?
        </h2>

        <div className="flex flex-col md:flex-row items-stretch md:items-center justify-center gap-1 md:gap-4 text-center" data-id="element-218">
          <div className="flex items-center gap-2 justify-center py-1" data-id="element-219">
            <div className="w-7 h-7 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 flex-shrink-0" data-id="element-220">
              <MailIcon className="w-3.5 h-3.5" data-id="element-221" />
            </div>
            <p className="text-gray-700 text-sm" data-id="element-222">
              <span className="font-bold" data-id="element-223">1.</span> Comprás e ingresás tu correo
            </p>
          </div>
          <span className="hidden md:block text-gray-300" data-id="element-224">→</span>
          <div className="flex items-center gap-2 justify-center py-1" data-id="element-225">
            <div className="w-7 h-7 bg-green-100 rounded-full flex items-center justify-center text-green-600 flex-shrink-0" data-id="element-226">
              <CreditCardIcon className="w-3.5 h-3.5" data-id="element-227" />
            </div>
            <p className="text-gray-700 text-sm" data-id="element-228">
              <span className="font-bold" data-id="element-229">2.</span> Pagás de forma segura
            </p>
          </div>
          <span className="hidden md:block text-gray-300" data-id="element-230">→</span>
          <div className="flex items-center gap-2 justify-center py-1" data-id="element-231">
            <div className="w-7 h-7 bg-purple-100 rounded-full flex items-center justify-center text-purple-600 flex-shrink-0" data-id="element-232">
              <DownloadIcon className="w-3.5 h-3.5" data-id="element-233" />
            </div>
            <p className="text-gray-700 text-sm" data-id="element-234">
              <span className="font-bold" data-id="element-235">3.</span> Recibís el link de descarga
            </p>
          </div>
        </div>

        <p className="mt-1.5 text-xs text-gray-500 text-center" data-id="element-236">
          ⚠️ Si no lo ves en tu bandeja principal, revisá spam.
        </p>
      </div>
    </section>;
}